import { createContext, useContext, type ReactNode } from "react";

interface AdminPreviewContextValue {
  isAdminPreview: boolean;
  previewBrandId: string | null;
  readOnly: boolean;
}

const AdminPreviewContext = createContext<AdminPreviewContextValue>({
  isAdminPreview: false,
  previewBrandId: null,
  readOnly: false,
});

interface AdminPreviewProviderProps {
  previewBrandId: string;
  children: ReactNode;
}

export function AdminPreviewProvider({ previewBrandId, children }: AdminPreviewProviderProps) {
  return (
    <AdminPreviewContext.Provider value={{ isAdminPreview: true, previewBrandId, readOnly: true }}>
      {children}
    </AdminPreviewContext.Provider>
  );
}

export function useAdminPreview() {
  return useContext(AdminPreviewContext);
}